// extracted by mini-css-extract-plugin
export default {"user":"UserButton_user__SWxb4"};